function nelderMead(f, x0, parameters) {
	const dim = x0.length;
	const maxIterations = (parameters === null || parameters === void 0 ? void 0 : parameters.maxIterations) ?? x0.length * 200;
	const nonZeroDelta = (parameters === null || parameters === void 0 ? void 0 : parameters.nonZeroDelta) ?? .15;
	const zeroDelta = (parameters === null || parameters === void 0 ? void 0 : parameters.zeroDelta) ?? .001;
	const minErrorDelta = (parameters === null || parameters === void 0 ? void 0 : parameters.minErrorDelta) ?? 1e-6;
	const minTolerance = (parameters === null || parameters === void 0 ? void 0 : parameters.minErrorDelta) ?? 1e-5;
	const rho = (parameters === null || parameters === void 0 ? void 0 : parameters.rho) ?? 1;
	const chi = (parameters === null || parameters === void 0 ? void 0 : parameters.chi) ?? 1 + 2 / dim;
	const psi = (parameters === null || parameters === void 0 ? void 0 : parameters.psi) ?? -1 * (.75 - 1 / (2 * dim));
	const sigma = (parameters === null || parameters === void 0 ? void 0 : parameters.sigma) ?? 1 - 1 / dim;
	const history = (parameters === null || parameters === void 0 ? void 0 : parameters.history) ?? void 0;
	const simplex = [];
	simplex.push({
		point: x0.slice(),
		fx: f(x0.slice()),
		id: 0
	});
	for (let i = 0; i < dim; i++) {
		const newPoint = [...x0];
		newPoint[i] = newPoint[i] ? newPoint[i] + nonZeroDelta : zeroDelta;
		simplex.push({
			point: newPoint,
			fx: f(newPoint),
			id: i + 1
		});
	}
	function updateSimplex(value) {
		for (let i = 0; i < value.point.length; i++) simplex[dim].point[i] = value.point[i];
		simplex[dim].fx = value.fx;
	}
	const sortOrder = function(a, b) {
		return a.fx - b.fx;
	};
	const centroid = {
		point: x0.slice(),
		fx: 0,
		id: 0
	};
	const reflected = {
		point: x0.slice(),
		fx: 0,
		id: 0
	};
	const contracted = {
		point: x0.slice(),
		fx: 0,
		id: 0
	};
	const expanded = {
		point: x0.slice(),
		fx: 0,
		id: 0
	};
	for (let iteration = 0; iteration < maxIterations; ++iteration) {
		simplex.sort(sortOrder);
		if (history) {
			const sortedSimplex = simplex.map(function(x) {
				return {
					point: x.point.slice(),
					fx: x.fx,
					id: x.id
				};
			});
			sortedSimplex.sort(function(a, b) {
				return a.id - b.id;
			});
			history.push(sortedSimplex);
		}
		let maxDiff = 0;
		for (let i = 0; i < dim; ++i) maxDiff = Math.max(maxDiff, Math.abs(simplex[0].point[i] - simplex[1].point[i]));
		if (Math.abs(simplex[0].fx - simplex[dim].fx) < minErrorDelta && maxDiff < minTolerance) break;
		for (let i = 0; i < dim; ++i) {
			centroid.point[i] = 0;
			for (let j = 0; j < dim; ++j) centroid.point[i] += simplex[j].point[i];
			centroid.point[i] /= dim;
		}
		const worst = simplex[dim];
		weightedSum(reflected.point, 1 + rho, centroid.point, -rho, worst.point);
		reflected.fx = f(reflected.point);
		if (reflected.fx < simplex[0].fx) {
			weightedSum(expanded.point, 1 + chi, centroid.point, -chi, worst.point);
			expanded.fx = f(expanded.point);
			if (expanded.fx < reflected.fx) updateSimplex(expanded);
			else updateSimplex(reflected);
		} else if (reflected.fx >= simplex[dim - 1].fx) {
			let shouldReduce = false;
			if (reflected.fx > worst.fx) {
				weightedSum(contracted.point, 1 + psi, centroid.point, -psi, worst.point);
				contracted.fx = f(contracted.point);
				if (contracted.fx < worst.fx) updateSimplex(contracted);
				else shouldReduce = true;
			} else {
				weightedSum(contracted.point, 1 - psi * rho, centroid.point, psi * rho, worst.point);
				contracted.fx = f(contracted.point);
				if (contracted.fx < reflected.fx) updateSimplex(contracted);
				else shouldReduce = true;
			}
			if (shouldReduce) {
				if (sigma >= 1) break;
				for (let i = 1; i < simplex.length; ++i) {
					weightedSum(simplex[i].point, 1 - sigma, simplex[0].point, sigma, simplex[i].point);
					simplex[i].fx = f(simplex[i].point);
				}
			}
		} else updateSimplex(reflected);
	}
	simplex.sort(sortOrder);
	return {
		fx: simplex[0].fx,
		x: simplex[0]
	};
}
function weightedSum(ret, w1, v1, w2, v2) {
	for (let j = 0; j < ret.length; ++j) ret[j] = w1 * v1[j] + w2 * v2[j];
}
export { nelderMead };

//# sourceMappingURL=index71.js.map